// extracted by mini-css-extract-plugin
export default {"tooltip":"NV-z","arrow":"OV-z"};